<template>
  <main class="app-auth-shell__main--hero">
    <div class="mx-auto w-full max-w-4xl">
      <div class="app-auth-shell__card--hero">
        <img
          src="../../assets/logo-blue-wide-small.png"
          alt="Givaroo"
          class="mx-auto h-24 w-auto sm:h-32 lg:h-36"
        />

        <p
          class="mt-6 text-xs font-semibold uppercase tracking-[0.22em] text-primaryAccent sm:text-sm"
        >
          A fundraising processing platform
        </p>

        <h1
          class="mt-4 text-2xl font-semibold leading-tight text-gray-900 sm:text-3xl lg:text-[2rem]"
        >
          Power your canvassing teams with fast, reliable donation processing
        </h1>

        <p class="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-gray-600 sm:text-lg">
          Collect donations in the field, manage campaigns, and track fundraiser performance all in
          one place.
        </p>

        <div class="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
          <BaseButton
            v-if="!isLoggedIn"
            variant="primary"
            size="md"
            :icon="ArrowRightIcon"
            icon-position="trailing"
            data-cy="login"
            @click="goToLogin"
          >
            Log In
          </BaseButton>
          <BaseButton
            v-else
            variant="primary"
            size="md"
            :icon="ArrowRightIcon"
            icon-position="trailing"
            @click="goToDashboard"
          >
            Go to Dashboard
          </BaseButton>
        </div>
      </div>

      <div class="mx-auto mt-10 grid max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-5">
        <article
          v-for="feature in features"
          :key="feature.title"
          class="app-auth-shell__feature-card"
        >
          <div class="app-auth-shell__feature-icon">
            <component :is="feature.icon" class="h-5 w-5" aria-hidden="true" />
          </div>
          <h2 class="text-sm font-semibold text-gray-900">{{ feature.title }}</h2>
          <p class="mt-1 text-sm leading-relaxed text-gray-600">{{ feature.description }}</p>
        </article>
      </div>
    </div>
  </main>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import {
  ArrowRightIcon,
  ChartBarIcon,
  ShieldCheckIcon,
  UserGroupIcon,
} from '@heroicons/vue/24/outline'

const router = useRouter()
const store = useStore()

const isLoggedIn = computed(() => store.getters.isLoggedIn)

const features = [
  {
    title: 'Field-ready donations',
    description: 'Process gifts on the spot with a workflow built for canvassers and fundraisers.',
    icon: ShieldCheckIcon,
  },
  {
    title: 'Campaign visibility',
    description: 'Track performance, assignments, and activity across every active campaign.',
    icon: ChartBarIcon,
  },
  {
    title: 'Team coordination',
    description: 'Keep admins, field directors, and fundraisers aligned in one platform.',
    icon: UserGroupIcon,
  },
]

function goToLogin() {
  router.push({ name: 'Login' })
}

function goToDashboard() {
  router.push({ name: 'CampaignList' })
}
</script>
